import { render, staticRenderFns } from "./UnifiedSignedTodo.vue?vue&type=template&id=212ce7cd&"
import script from "./UnifiedSignedTodo.vue?vue&type=script&lang=js&"
export * from "./UnifiedSignedTodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212ce7cd')) {
      api.createRecord('212ce7cd', component.options)
    } else {
      api.reload('212ce7cd', component.options)
    }
    module.hot.accept("./UnifiedSignedTodo.vue?vue&type=template&id=212ce7cd&", function () {
      api.rerender('212ce7cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/static/UnifiedSignedTodo.vue"
export default component.exports